module.exports = __webpack_public_path__ + "media/images/professional_profiles-dcd3838f7c5c259084379d0b2ba5f57c.jpeg";